<section class="legal-notice">

  <h1 class="legal-notice__title">{{ 'generic.legal_notice' | translate }}</h1>

  @if (showLoader) {
    <div
      class="legal-notice__spinner-wrapper spinner-wrapper">
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (!showLoader) {
    <mat-accordion
      class="legal-notice__accordion">
      @for (page of pagesReady; track page; let index = $index) {
        <mat-expansion-panel
          [attr.id]="'focus_'+index"
          (afterExpand)="focus(index)"
          class="legal-notice__panel"
          hideToggle>
          <mat-expansion-panel-header class="legal-notice__panel-header">
            <mat-icon class="legal-notice__panel-icon"
              [svgIcon]="page.icon">
            </mat-icon>
            <h2 class="legal-notice__panel-title"
              [innerHTML]="page.title">
            </h2>
            <mat-icon class="legal-notice__arrow-icon"
              svgIcon="arrow-forward-ios-rounded">
            </mat-icon>
          </mat-expansion-panel-header>
          <div class="legal-notice__panel-content"
            [innerHTML]="page.body">
          </div>
            <mat-accordion *ngIf="page.children?.length"
                           class="legal-notice__accordion legal-notice__accordion--inner">
                <mat-expansion-panel *ngFor="let child of page.children; let childIndex = index"
                                     class="legal-notice__panel legal-notice__panel--inner"
                                     hideToggle>
                    <mat-expansion-panel-header class="legal-notice__panel-header legal-notice__panel-header--inner">
                        <h3 class="legal-notice__panel-title legal-notice__panel-title--inner"
                            [innerHTML]="child.title">
                        </h3>
                        <mat-icon class="legal-notice__arrow-icon"
                                  svgIcon="arrow-forward-ios-rounded">
                        </mat-icon>
                    </mat-expansion-panel-header>
                    <div class="legal-notice__panel-content legal-notice__panel-content--inner"
                         [innerHTML]="child.body">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }

</section>
